// extracted by mini-css-extract-plugin
export var cartContainer = "_g3-4";
export var gray = "_g3-1";
export var itemContainer = "_g3-2";
export var itemDetails = "_g3-3";
export var strong = "_g3-0";